<template>
<div>
  <div class="full" style="display: flex; flex-direction: column;">
    <div style="flex: 1 auto">
      <div style="display: flex; padding-left: 79px">
          <div>
            <img class="logo" src="../assets/imgs/logo.svg" />
          </div>
          <div>
            <img src="../assets/imgs/kippe.svg" />
          </div>
          <div style="align-self: stretch; position: relative">
            <div class="text-container">
              <p>TON DESIGN</p>
              <p><strong>SI OUI, ALORS WINSTON</strong></p>
            </div>
          </div>
      </div>
      <div class="start">
          <b-button @click="onClickButton()" size="lg" variant="secondary">Commencer</b-button>
      </div>
    </div>
  </div>
  <!-- <div class="disclaimer">
    <p>Platz für Disclaimer: Die Aktion richtet sich nur an volljährige Raucher mit gemeldetem Wohnsitz in Deutschland…Teilnahmeschluss für die Aktion ist der …. Pro Person ist die Teilnahme nur einmal möglich. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna Excepteur sint</p>
  </div> -->
</div>
</template>

<script>
export default {
  name: "Home",
  methods: {
    onClickButton () {
      this.$emit('start')
    }
  }
}
</script>
<style lang="scss" scoped>
.disclaimer {
  p {
    width: 666px;
    margin-left: auto;
    margin-right: auto;
    font-size: 12px;
    color: #939393;
    font-family: Helvetica;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 16px;
    opacity: 0.8;
  }
  padding-top: 25px;
  padding-bottom: 25px;
  background-color: white;
}
img.logo {
  margin-left: 36px;
  margin-right: 21px;
}
.full {
  height: 100vh;
  max-height: 100vh;
  padding-top: 165px;
  max-width: 810px;
  margin-left: auto;
  margin-right: auto;
}
.text-container {
  margin-top: auto;
  position: absolute;
  bottom: 0;
  white-space: nowrap;
  padding-left: 13px;
}
.button-wrapper {
  padding-top: 90px
}
.start {
  text-align: center;
  margin-top: 100px;
}
p {
  margin: 0;
  padding: 0;
  font-size: 31px;
  line-height: 0.85;
}
</style>
